import { zoneConfig } from '@rx-angular/cdk/zone-configurations';

zoneConfig.global.disable.requestAnimationFrame();
zoneConfig.global.disable.timers();
zoneConfig.events.disable.UNPATCHED_EVENTS(['load', 'error', 'close', 'open']);
zoneConfig.events.disable.PASSIVE_EVENTS(['scroll', 'wheel', 'mousewheel', 'touchstart', 'touchmove']);
zoneConfig.unpatchXHR();
